import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import { RESERVE_IS_POSSIBLE, SPECIAL_DATA_TEXTS } from 'src/app/modules/route-planner/constants/multi-language.constants';
import {
  TRAVELING_BY_CAR,
  WALKING,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { eSectionType } from 'src/app/modules/route-planner/enums/route-planning/section-type.enum';
import { eTransportMode } from 'src/app/modules/route-planner/enums/route-planning/transport-mode.enum';
import { Agency } from 'src/app/modules/route-planner/interfaces/route-planning/agency.interface';
import { Section } from 'src/app/modules/route-planner/interfaces/route-planning/section.interface';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';


@Component({
    selector: 'app-source-destination-results-list-item-section',
    templateUrl: './source-destination-results-list-item-section.component.html',
    styleUrls: ['./source-destination-results-list-item-section.component.scss'],
    standalone: false
})
export class SourceDestinationResultsListItemSectionComponent implements OnInit {
  @Input() section: Section;

  sectionTypes = eSectionType;
  trasportModes = eTransportMode;
  timeText: string
  /**
   * Localized SR-only accessible names for the mode icons. The icons (walking
   * person / car) carry information visually; SR users get the mode via
   * role="img" + aria-label here.
   */
  walkingText: string
  vehicleText: string
  accessibleText: string
  flexibleText: string
  accessibleWithOrderText: string
  reserveInAdvancedText: string
  agencyId: number

  constructor(private readonly languageService: LanguageService, public readonly routePlanningService: RoutePlanningService, private readonly modalService: ModalService) { }

  ngOnInit(): void {
    this.initializeMultiLanguageTexts()
    this.agencyId = parseInt(this.section.agency?.id)
  }

  calcSectionDuration(duration: number) {
    this.timeText = this.routePlanningService.calcSectionDuration(duration);
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.calcSectionDuration(this.section.travelSummary.duration)
      this.walkingText = WALKING[language.language]
      this.vehicleText = TRAVELING_BY_CAR[language.language]
      this.accessibleText = SPECIAL_DATA_TEXTS.accessible[language.language]
      this.flexibleText = SPECIAL_DATA_TEXTS.flexible[language.language]
      this.accessibleWithOrderText = SPECIAL_DATA_TEXTS.accessibleWithOrder[language.language]
      this.reserveInAdvancedText = RESERVE_IS_POSSIBLE[language.language]
    })
  }

  openFlexibleModal(isOrder: boolean) {
    if (this.agencyId) {
      this.modalService.openAgencyContactInfoModal(this.agencyId, isOrder);
    }
  }

  openAccissibleModal() {
    if (this.agencyId) {
      this.modalService.openAgencyContactInfoModal(this.agencyId, this.section.specialData.isCallNeeded ? true : false);
    }
  }
}
